import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "itens-envio-checklist"
  }, [_vm._l(_vm.itens, function (item) {
    return _c('div', {
      key: item.key,
      staticClass: "itens-envio-checklist__item",
      class: {
        'itens-envio-checklist__item--disabled': !item.available
      }
    }, [_c('b-form-checkbox', {
      attrs: {
        "checked": _vm.isSelecionado(item.key),
        "disabled": _vm.disabled || !item.available
      },
      on: {
        "change": function change($event) {
          return _vm.alterar(item.key, $event);
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.label))])]), _c('small', {
      staticClass: "text-muted d-block ml-7"
    }, [_vm._v(" " + _vm._s(item.description) + " ")])], 1);
  }), _vm.error ? _c('small', {
    staticClass: "text-danger d-block mt-2"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };